// author: Caleb Yearsley (caleb.yearsley@tecuity.com)
// date: 2019-07-22

import "./MySectionsView.less";

import cloneDeep from "lodash/cloneDeep";
import * as React from "react";

import { SectionApi } from "lib/api";
import { CancellationToken } from "lib/api/base";
import { IBaseProps } from "lib/data/interfaces";
import { Section } from "lib/data/model";
import { ComponentService, StateService } from "lib/services";

import { GradientBar } from "components/general";
import { SectionPage } from "components/pages";

interface IMySectionsViewProps extends IBaseProps {

}

interface IMySectionsViewState {

	sections: Section[];
	sectionHierarchies: { [key: string]: Section[] };
}

export class MySectionsView extends React.Component<IMySectionsViewProps, IMySectionsViewState> {

	private apiCancellationToken: CancellationToken = new CancellationToken();


	public constructor(props: IMySectionsViewProps) {

		super(props);

		this.state = {
			sections: [],
			sectionHierarchies: {}
		};
	}

	public async componentWillMount() {

		// Query Sections Owned By The Current User
		const sections = await SectionApi.getOwnedSections();

		sections.forEach((section) => {

			if (section.id !== undefined && this.state.sectionHierarchies[section.id] === undefined) {

				this.requestSectionHierarchy(section);
			}
		});

		// Set The State Of "Sections"
		StateService.setCancelableState(() => this.setState({ sections }), this.apiCancellationToken);
	}

	public async componentWillReceiveProps() {

		// Query Sections Owned By The Current User
		const sections = await SectionApi.getOwnedSections();

		sections.forEach((section) => {

			if (section.id !== undefined && this.state.sectionHierarchies[section.id] === undefined) {

				this.requestSectionHierarchy(section);
			}
		});

		// Set The State Of "Sections"
		StateService.setCancelableState(() => this.setState({ sections }), this.apiCancellationToken);
	}

	public componentWillUnmount() {

		// Cancel Outstanding API Calls
		this.apiCancellationToken.cancel();
	}

	public render() {

		// Define Class Name(s)
		const className = [
			"my-sections-view",
			this.props.className
		].filter((v) => v !== undefined && v !== null).join(" ");

		return (
			<section className={className}>

				<GradientBar
					className="title-gradient-bar"
					size="large"
					title="My Sections"
				/>

				<div className="section-list-container">

					{(this.state.sections.length > 0
						?
						this.state.sections.map((section) => {

							let sectionTitle: string = "";

							if (section.published !== undefined) {

								sectionTitle = section.published.name;
							}
							else if (section.draft) {

								sectionTitle = `${section.draft.name} (DRAFT ONLY)`;
							}

							return (

								<GradientBar
									key={section.id}
									className="section-gradient-bar"
									size="medium"
									title={sectionTitle}
									href={`${SectionPage.BasePath}/${section.id}`}
									superTitle={this.getSectionSuperTitle(section.id)}
								/>
							);
						})
						:
						<span>No Directly Assigned Sections</span>
					)}

				</div>
			</section>
		);

	}

	/**
	 * Gets the section super title
	 */
	private getSectionSuperTitle = (sectionId: number | undefined): string | undefined => {

		if (sectionId !== undefined && this.state.sectionHierarchies[sectionId] !== undefined) {

			return ComponentService.getHierarchyString(this.state.sectionHierarchies[sectionId]);
		}

		return undefined;
	}

	/**
	 * Requests the hierarchy for the specified section, then caches it in the state
	 */
	private requestSectionHierarchy = async (section: Section) => {

		if (section.id !== undefined) {

			// query the heirarchy for the specified section
			const sectionHierarchy = await SectionApi.getHierarchy(section.id);

			const clonedState = Object.assign(
				cloneDeep(this.state.sectionHierarchies), { [section.id]: sectionHierarchy }
			);

			StateService.setCancelableState(() => this.setState({
				sectionHierarchies: clonedState
			}), this.apiCancellationToken);
		}
	}
}
